import { EmailCategory, EmailCategoryPreference } from "types/generated/models";

export type EmailPreferenceValues = Record<EmailCategory, boolean>;

export interface IEmailCategoryOption {
    category: EmailCategory;
    label: string;
    description: string;
    testIdSuffix: string;
}

export const EMAIL_CATEGORY_OPTIONS: IEmailCategoryOption[] = [
    {
        category: EmailCategory.PracticeCommunications,
        label: "Practice Communications",
        description: "Forms, clinical notes and general communication",
        testIdSuffix: "practice_communications",
    },
    {
        category: EmailCategory.AppointmentReminders,
        label: "Appointment Reminders",
        description: "Appointment reminder emails",
        testIdSuffix: "appointment_reminders",
    },
    {
        category: EmailCategory.Invoicing,
        label: "Invoicing",
        description: "Invoices, statements and receipts",
        testIdSuffix: "invoicing",
    },
];

// The page always starts with every category off, whatever the client's current settings are.
export const allOff = (): EmailPreferenceValues =>
    Object.fromEntries(EMAIL_CATEGORY_OPTIONS.map(({ category }) => [category, false])) as EmailPreferenceValues;

export const toPreferenceList = (values: EmailPreferenceValues): EmailCategoryPreference[] =>
    EMAIL_CATEGORY_OPTIONS.map(({ category }) => ({ category, receives: values[category] }));

export const receivesNothing = (values: EmailPreferenceValues): boolean =>
    EMAIL_CATEGORY_OPTIONS.every(({ category }) => !values[category]);
